import "core-js/modules/es.array.filter.js";
import "core-js/modules/esnext.async-iterator.filter.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/es.object.to-string.js";
import 'abort-controller/polyfill';
import 'intersection-observer';
import Vue from 'vue';
import ChunkLoadError from '@/plugins/chunk-load-error';
import desensitize from '@/shared/filters/desensitize';
import cent2yuan from '@/shared/filters/cent2yuan';
import formatAmount from '@/shared/filters/formatAmount';
import formatDiscount from '@/shared/filters/formatDiscount';
import App from './App.vue';
import { Locale } from 'vant';
import { createRouter } from './router';
import { installGuards } from './guards';
import VueClipboard from 'vue-clipboard2';
import SvgIcon from '@/x-components/svg-icon';
import NavBar from '@/x-components/nav-bar';
import Popup from '@/x-components/popup';
import { Toast, Notify, Dialog, Lazyload } from 'vant';
import formatTime from '@/shared/filters/formatTime';
import createPinia from '@/stores';
import mergeSetup from './mergeSetup';
import 'vant/es/toast/style/less';
import 'vant/es/notify/style/less';
import 'vant/es/dialog/style/less';
import 'vant/es/lazyload/style/less';
import '@/styles/vars.css';
import '@/styles/reset.css';
import '@/styles/base.css';
import '@/assets/font/index.css';
import '../vant-extra/style-override/index.css';
// eslint-disable-next-line
// @ts-ignore
import enES from 'vant/es/locale/lang/es-ES';
Locale.use('en-US', enES);
// for Vue 2.7/3.x mixin setup
// mixin can merge setup, should delete
Vue.config.optionMergeStrategies.setup = mergeSetup;
Vue.use(VueClipboard);
// vant component
Vue.use(Toast);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Lazyload);
// global component
Vue.use(SvgIcon);
Vue.use(Popup);
Vue.use(NavBar);
var router = createRouter();
var pinia = createPinia();
Vue.use(ChunkLoadError, {
    router: router
});
/**
 * set all toast default params
 */ Toast.setDefaultOptions({
    duration: 3000
});
/**
 * set all dialog default params
 */ Dialog.setDefaultOptions({
    closeOnPopstate: false
});
Vue.filter('desensitize', desensitize);
Vue.filter('cent2yuan', cent2yuan);
Vue.filter('formatAmount', formatAmount);
Vue.filter('formatDiscount', formatDiscount);
Vue.filter('formatTime', formatTime);
/**
 * export global router for axios
 */ window.__g_router__ = router;
/**
 * install router's beforeEach/afterEach
 */ installGuards(router, pinia);
/**
 * export global app
 */ window.__g_app__ = new Vue({
    router: router,
    pinia: pinia,
    data: function() {
        return {
            isRouterAlive: true
        };
    },
    render: function(h) {
        if (this.isRouterAlive) {
            return h(App);
        }
        return h();
    },
    methods: {
        /**
     * force update current page
     */ forceReload: function() {
            var _this = this;
            this.isRouterAlive = false;
            this.$nextTick(function() {
                _this.isRouterAlive = true;
            });
        }
    }
}).$mount('#app');
